/**
 * 檔案用途區塊
 * @module AppleSsoPage
 * @purpose 組合 Apple 登入元件並掛載於頁面內容版型，作為 Apple SSO 入口頁。
 * @external https://innotech.atlassian.net/browse/IN-132134
 */
import React from 'react';
import ContentLayout from '@shared/components/ContentLayout';
import AppleLogin from '@modules/apple/components/AppleLogin';

/**
 * 宣告內容用途說明與單號關聯
 * @description Apple SSO 頁面元件，負責渲染內容版型與 AppleLogin。
 * @purpose 提供使用者進入 Apple 單一登入流程的頁面容器。
 * @external https://innotech.atlassian.net/browse/IN-132134
 */
const AppleSsoPage = () => {
  return (
    <ContentLayout testId="AppleSsoPage">
      <AppleLogin />
    </ContentLayout>
  );
};

export default AppleSsoPage;

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:09:51.863Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotation layout (top/middle/bottom) in Chinese titles, mapped declaration to ticket IN-132134 using full Jira URL, and kept runtime logic unchanged.
 */
